import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=72e542bf"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=js"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&id=72e542bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports